import { useQuery } from '@tanstack/react-query';

import {
    downloadSMS,
    getSMS,
    getSMSByUserId,
} from '../../api/messagging/smsApi';
import { OmnichannelMessage } from '../../../types';

const mapSmsToOmnichannel = (sms: Awaited<ReturnType<typeof getSMS>>['data']): OmnichannelMessage[] => {
    return sms.map(item => ({
        id: String(item.id),
        patientId: item.phone_number || 'unknown',
        patientName: item.phone_number || 'Unknown',
        channel: 'sms',
        direction: item.direction === 'inbound' ? 'inbound' : 'outbound',
        timestamp: new Date(item.timestamp),
        content: item.body || '',
        // status: 'delivered',
    }));
};

export const useGetSMS = (params?: Partial<Parameters<typeof getSMS>[0]>) => {
    const resolvedParams = {
        page: params?.page ?? 1,
        limit: params?.limit ?? 10,
    };

    return useQuery({
        queryKey: ['sms', resolvedParams],
        queryFn: async () => {
            const response = await getSMS(resolvedParams);
            const mapped = mapSmsToOmnichannel(response.data);
            return {
                data: mapped,
                pagination: response.pagination,
            };
        },
    });
};

export const useGetSMSByUserId = (userId?: number) => {
    return useQuery({
        queryKey: ['sms-by-user', userId],
        queryFn: async () => {
            if (typeof userId !== 'number') throw new Error('User id is required');
            const response = await getSMSByUserId(userId);
            const mapped = mapSmsToOmnichannel(response.data);
            return {
                data: mapped,
                pagination: response.pagination,
            };
        },
        enabled: typeof userId === 'number',
    });
};

export const useDownloadSMS = (
    params?: { 
        user_id: number,
        format: 'json' | 'csv' | 'txt'
    }) => {
    return useQuery({
        queryKey: ['download-sms', params],
        queryFn: async () => {
            const response = await downloadSMS(params);
            return response;
        },
        enabled: false, // Disable automatic query execution
    });
};

